import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const editPublisherSingleAppAction = createAsyncThunk(
    'get-publisher-single-app-data',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.put(`/admins/api/edit-publisher-app`,data) 
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const editPublisherSingleAppSlice = createSlice({
    name: 'get-publisher-single-app-data',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(editPublisherSingleAppAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(editPublisherSingleAppAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(editPublisherSingleAppAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const editSinglePublisherAppReducer = editPublisherSingleAppSlice.reducer